import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ProjectHoursBillingBy } from '@work4all/models/lib/Enums/ProjectHoursBillingBy.enum';

import { FixedDataPicker } from '../fixed-data-picker/FixedDataPicker';
import { IPickerProps } from '../types';

export type ProjectHoursBillingByPickerProps<TMultiple extends boolean> =
  IPickerProps<{ id: ProjectHoursBillingBy; name: string }, TMultiple>;

export function ProjectHoursBillingByPicker<TMultiple extends boolean>(
  props: ProjectHoursBillingByPickerProps<TMultiple>
) {
  const { t } = useTranslation();

  const dataSet = useMemo(() => {
    return Object.keys(ProjectHoursBillingBy)
      .filter((x) => x !== 'PROJECT')
      .map((by) => {
        return {
          id: by,
          name: t(`PROJECT_HOURS_BILLING_BY.${by}`),
        };
      });
  }, [t]);

  return <FixedDataPicker {...props} dataSet={dataSet} />;
}
